var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabShrink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2815_10364)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 2,
    width: 30,
    height: 30,
    rx: 4,
    transform: "rotate(90 34 2)",
    fill: "#F9F1DD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.75,
    y: 2.25,
    width: 29.5,
    height: 29.5,
    rx: 3.75,
    transform: "rotate(90 33.75 2.25)",
    stroke: "#FFDC8A",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9792 15.525C21.0914 17.5591 23.1587 19.5509 25.228 21.5404C25.3741 21.6803 25.5232 21.8334 25.6943 21.919C26.1042 22.1228 26.6059 21.9263 26.8416 21.5055C27.0899 21.0617 27.0523 20.5228 26.6862 20.1394C26.172 19.6004 25.6286 19.0988 25.0945 18.5839C23.2943 16.8477 21.494 15.1102 19.6906 13.3775C19.1774 12.8844 18.7915 12.8735 18.295 13.3498C16.0107 15.5443 13.7223 17.7339 11.46 19.9585C11.2138 20.2008 11.0031 20.6554 11 21.0147C10.9979 21.3125 11.2806 21.7924 11.5174 21.8696C11.8303 21.9721 12.309 21.8937 12.5635 21.6646C13.8235 20.53 15.0324 19.3207 16.2611 18.139C17.1539 17.2793 18.0478 16.4208 18.9792 15.525Z",
    fill: "#DEA829"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2815_10364",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2815_10364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2815_10364",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabShrink);
export default __webpack_public_path__ + "static/media/tab_shrink.d9e8b9a2dae9099023f518abe85569e3.svg";
export { ForwardRef as ReactComponent };